// passing the path into variables

const destination1 = '/assets/santarosa/destinations/arica.webp';
const destination2 = '/assets/santarosa/destinations/iquique.webp';
const destination3 = '/assets/santarosa/destinations/calama.webp';
const destination4 = '/assets/santarosa/destinations/alto-hospicio.webp';
const destination5 = '/assets/santarosa/destinations/la-tirana.webp';
const destination6 = '/assets/santarosa/destinations/iquique.webp';
const destination7 = '/assets/santarosa/destinations/calama.webp';
const destination8 = '/assets/santarosa/destinations/alto-hospicio.webp';
const destination9 = '/assets/santarosa/destinations/la-tirana.webp';

const destination = [
	destination1,
	destination2,
	destination3,
	destination4,
	destination5,
	destination6,
	destination7,
	destination8,
	destination9,
];

const recomendation1 = '/assets/santarosa/recomendations/bowling.webp';
const recomendation2 = '/assets/santarosa/recomendations/hotel.webp';
const recomendation3 = '/assets/santarosa/recomendations/resort.webp';

const recomendations = [
	{ path: recomendation1, url: 'http://www.oxbowling.cl/' },
	{ path: recomendation2, url: 'http://www.espacioox.cl/' },
	{ path: recomendation3, url: 'http://www.resortsantarosa.cl' },
];

const santarosaSlides = {
	destination,
	recomendations,
};

export default santarosaSlides;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getSlides/santarosaSlides.js